// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"89749323","209":"79483a9a","219":"02468a75","375":"30cc64e5","444":"a8f5a375","488":"174ee998","540":"41d250ba","625":"bfc1a247","642":"16e0eaad","708":"1407fc2b","803":"3e0473a9"}[chunkId] + ".chunk.js";
};